import { EIdentifikaceOsoby } from 'enums/amlz/identifikaceOsoby';

const identifikaceOsobySelect = [
    {
        value: EIdentifikaceOsoby.ELEKTRONICKY_PODPIS,
        labelcz: 'ELEKTRONICKY_PODPIS'
    },
    {
        value: EIdentifikaceOsoby.DOKLADY_TOTOZNOSTI,
        labelcz: 'DVA_DOKLADY_TOTOZNOSTI'
    }
];

export default identifikaceOsobySelect;
